import React from "react";
import { I2cInput } from "@webcomponents/i2cwebcomponents/dist/react";

import "../../PrepaidComponents/Prepaid.scss";
import { Controller } from "react-hook-form";
import { inputChangeHandler } from "../../PrepaidComponents/ProgramInformation/FieldsListingLabels";

const NewProgamForm = ({ control, handleValueChanges, methods, errors }) => {
  return (
    <div className="forms-instance">
      <div i2c-grid="grid gap-sm">
        <div i2c-grid="12">
          <div className="sub-heading">New Program Projections</div>
          <div className="custom-label-light">
             First year projctions.
          </div>
        </div>
        <div i2c-grid="12">
          <div className="custom-label mb-6">
          Estimated Count{" "}
            <span className="custom-label-light">(Number of cards to be migrated)</span>
           
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_ecount_1"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q1 Estimate"
                      onI2cInput={(e) => {
                        const value = inputChangeHandler(e);
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_ecount_1"}
                      
                    />
                  )}
                />
             
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_ecount_2"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q2 Estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_ecount_2"}
                    
                    />
                  )}
                />
            
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_ecount_3"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q3 Estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_ecount_3"}
                      
                    />
                  )}
                />
             
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_ecount_4"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q4 Estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_ecount_4"}
                   
                    />
                  )}
                />
           
              </div>
            </div>
          </div>
        </div>
        <div i2c-grid="12">
          <div className="custom-label mb-6">
          Estimated Value{" "}
            <span className="custom-label-light">(Estimated transaction value)</span>
           
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evalue_1"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q1 Estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evalue_1"}
                    
                    />
                  )}
                />
               
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evalue_2"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q2 Estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evalue_2"}
                 
                    />
                  )}
                />
               
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evalue_3"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q3 Estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evalue_3"}
                     
                    />
                  )}
                />
           
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evalue_4"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q4 Estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evalue_4"}
                  
                    />
                  )}
                />
            
              </div>
            </div>
          </div>
        </div>
        <div i2c-grid="12">
          <div className="custom-label mb-6">
          Estimated  Volume{" "}
            <span className="custom-label-light">(Estimated transaction volume)</span>
           
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evolume_1"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q1 Estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evolume_1"}
                       
                    />
                  )}
                />
              
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evolume_2"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q2 Estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evolume_2"}
                     
                    />
                  )}
                />
               
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evolume_3"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q3 Estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evolume_3"}
                    
                    />
                  )}
                />
              
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_evolume_4"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q4 Estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_evolume_4"}
                    
                    />
                  )}
                />
          
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProgamForm;
